"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.MOBILE_HEIGHT = exports.InfoText = exports.DESKTOP_HEIGHT = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const MOBILE_HEIGHT = exports.MOBILE_HEIGHT = 273;
const DESKTOP_HEIGHT = exports.DESKTOP_HEIGHT = 285;
const Root = exports.Root = (0, _mui.styled)('div', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  theme,
  isSmsEnabled = false
}) => ({
  overflow: 'hidden',
  minHeight: isSmsEnabled ? 333 : MOBILE_HEIGHT,
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4),
  [theme.breakpoints.up('sm')]: {
    boxSizing: 'border-box',
    maxWidth: '100%',
    minHeight: isSmsEnabled ? 345 : DESKTOP_HEIGHT,
    width: 360
  }
}));
const InfoText = exports.InfoText = (0, _mui.styled)(_mui.Typography)(() => ({
  height: 40,
  overflow: 'hidden',
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical'
}));
